import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { OWL_DATE_TIME_LOCALE, OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ComponentsModule } from '@common/components/components.module';
import { ClientsViewComponent } from '@modules/clients/views/clientsView/clientsView.component';
import { ServicesModule } from '@common/services/services.module';
import { DayOfMonthDirective } from '@common/directives/DayOfMonthDirective/dayOfMonth.directive';
import { DisableInputDirective } from '@common/directives/DisableInputDirective/disableInputDirective';
import { ClientDetailsViewComponent } from './views/clientDetailsView/clientDetailsView';
import { AreaDetailsViewComponent } from './views/areaDetailsView/areaDetailsView';
import { TaskDetailsViewComponent } from './views/taskDetailsView/taskDetailsView.component';
import { AddEditTaskViewComponent } from './views/addEditTaskView/addEditTaskView.component';
import { EmployeesSelectComponent } from './views/addEditTaskView/EmployeesSelectComponent/employeesSelectComponent';
import { DayOfMonthComponent } from '@modules/clients/views/addEditTaskView/RepeatSelectComponent/DayOfMonthComponent/dayOfMonth.component';
import { RepeatSelectComponent } from './views/addEditTaskView/RepeatSelectComponent/repeatSelectComponent';
import { PeriodSelectComponent } from './views/addEditTaskView/RepeatSelectComponent/PeriodSelectComponent/periodSelect.component';
import { DaysOfWeekComponent } from './views/addEditTaskView/RepeatSelectComponent/DaysOfWeekComponent/daysOfWeek.component';
import { ProgressInAreaViewComponent } from './views/progressInAreaView/progressInAreaView';

@NgModule({
  declarations: [
    DayOfMonthDirective,
    AddEditTaskViewComponent,
    AreaDetailsViewComponent,
    ProgressInAreaViewComponent,
    ClientsViewComponent,
    ClientDetailsViewComponent,
    DayOfMonthComponent,
    DaysOfWeekComponent,
    DisableInputDirective,
    EmployeesSelectComponent,
    TaskDetailsViewComponent,
    PeriodSelectComponent,
    RepeatSelectComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TranslateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ComponentsModule,
    ServicesModule,
  ],
  exports: [],
  providers: [
    { provide: OWL_DATE_TIME_LOCALE, useValue: navigator.language },
  ],
})
export class ClientsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/clients/clients.module.ts